import { Box } from 'braid-design-system';

import { IconCertifiedSvg } from './IconCertifiedSvg';

export const IconCertified = () => (
  <Box component={IconCertifiedSvg} role="img" />
);
